import { render, staticRenderFns } from "./AssetAdmin.vue?vue&type=template&id=78acff3f&"
import script from "./AssetAdmin.vue?vue&type=script&lang=js&"
export * from "./AssetAdmin.vue?vue&type=script&lang=js&"
import style1 from "./AssetAdmin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports